import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["step", "dot", "prevBtn", "nextBtn"];
  static values = { index: Number, total: Number };

  connect() {
    this.element.querySelectorAll(".input-wrapper label").forEach((label) => {
      label.addEventListener("click", () => {
        label.closest(".input-wrapper")?.querySelector("input, select, textarea")?.focus();
      });
    });

    this.element.querySelectorAll(".checkbox-wrapper label").forEach((label) => {
      label.addEventListener("click", () => {
        label.closest(".checkbox-wrapper")?.querySelector("input[type='checkbox']")?.click();
      });
    });
  }

  indexValueChanged() {
    this.stepTargets.forEach((step, i) => {
      step.style.display = i === this.indexValue ? "" : "none";
    });

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("active", i === this.indexValue);
    });

    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.disabled = this.indexValue === 0;
    }
    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.disabled = this.indexValue >= this.totalValue - 1;
    }
  }

  next() {
    if (this.indexValue < this.totalValue - 1) {
      this.indexValue++;
    }
  }

  previous() {
    if (this.indexValue > 0) {
      this.indexValue--;
    }
  }
}
